import React, { useState } from 'react';
import Sidebar from 'components/Sidebar';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Container from 'components/Container';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';
import { createModel } from 'api/models';
import { useFeedback } from 'contexts/feedback';
import TextInput from 'components/Form/TextInput';
import SelectInput from 'components/Form/SelectInput';
import Button from 'components/Button';
import { EMBEDDING_OPTIONS, MODEL_OPTIONS } from 'helpers/models';

const TYPE_OPTIONS = [
    { value: 'model', label: 'Model' },
    { value: 'embedding', label: 'Embedding' },
];

export default function ModelsCreate() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const [selectedType, setSelectedType] = useState('model');
    const cache = useQueryClient();
    const navigate = useNavigate();
    const { setSuccess, setError } = useFeedback();

    const { mutate: create } = useMutation({
        mutationKey: ['createModel'],
        mutationFn: createModel,
        onSuccess: (data) => {
            cache.invalidateQueries(['models']);
            setSuccess("Modello creato con successo");
            return navigate(`/settings/models/${data._id || data.data?._id}`);
        },
        onError: (error) => {
            setError("Errore durante la creazione del modello");
            console.error("Error creating model:", error);
        }
    });

    function onSubmitHandler(e) {
        e.preventDefault();

        const data = {
            name: e.target.name.value,
            model: e.target.model.value,
            apiKey: e.target.apiKey.value,
            baseUrl: e.target.baseUrl.value,
            enabled: e.target.enabled.checked,
            type: e.target.type.value,
        }

        create(data);
    }

    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container className='!min-w-[700px] !max-w-[700px]'>
                    <div className='pb-8 pt-20 md:pt-14 text-center'>
                        <p className='text-3xl'>Aggiungi nuovo modello</p>
                    </div>

                    <div className=''>
                        <form onSubmit={onSubmitHandler} className='flex flex-col gap-4'>
                            <TextInput
                                label="Nome"
                                name="name"
                                placeholder="Nome identificativo del modello"
                                required
                            />
                            <SelectInput
                                label="Tipo"
                                name="type"
                                options={TYPE_OPTIONS}
                                defaultValue="model"
                                onChange={(e) => setSelectedType(e.target.value)}
                            />
                            <SelectInput
                                label="Modello"
                                name="model"
                                options={selectedType === 'embedding' ? EMBEDDING_OPTIONS : MODEL_OPTIONS}
                            />
                            <TextInput
                                label="API Key"
                                name="apiKey"
                                type="password"
                                placeholder="API Key del provider"
                                required
                            />
                            <TextInput
                                label="Base URL"
                                name="baseUrl"
                                placeholder="URL base del provider (opzionale)"
                            />
                            <div className='flex items-center gap-3'>
                                <input
                                    type="checkbox"
                                    name="enabled"
                                    id="enabled"
                                    defaultChecked={true}
                                    className='w-4 h-4 rounded border-light focus:ring-0'
                                />
                                <label htmlFor="enabled" className='text-sm'>Attivo</label>
                            </div>

                            <div className='flex justify-between pt-6'>
                                <Link to="/settings/models" className='hover:bg-grey text-white text-sm font-medium px-6 py-3 rounded-md transition-colors cursor-pointer duration-200'>Annulla</Link>
                                <Button submit>Salva</Button>
                            </div>
                        </form>
                    </div>

                </Container>
            </div>
        </>
    )
}
